import { IoChevronForward } from 'react-icons/io5';

interface Props {
  label: string;
  handleClick: () => void;
}

const ChevronCta: React.FC<Props> = ({ label, handleClick }) => {
  return (
    <div className="d-flex mt-1 align-items-center fz-15 cursor-pointer" onClick={handleClick}>
      <p style={{ lineHeight: '13px' }} className="pe-2">
        {label}
      </p>
      <IoChevronForward />
    </div>
  );
};

export default ChevronCta;
